import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const styles = {
    contentText : {
        marginLeft: '20px',
        marginRight: '20px'
    }
}

class DeleteInvoiceDialog extends Component {
    render() {
        const { open, invoicesToDelete } = this.props;
        const pluralString = invoicesToDelete.length > 1 ? 'invoices' : 'invoice';
        return (
            <Dialog className='delete-invoice' open={open}>
                <DialogTitle>Delete Invoice</DialogTitle>
                <DialogContentText 
                    id='delete-confirmation-text' 
                    style={styles.contentText}>
                    {`Are you sure that you want to delete the selected ` + pluralString +`?`}
                </DialogContentText>
                <DialogActions>
                    <Button id='confirm-invoice-delete'
                            onClick={() => this.props.onDeleteInvoices()}
                            color='primary'
                            >
                        Yes
                    </Button>
                    <Button 
                        onClick={() => this.props.onClose(false)}
                        >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DeleteInvoiceDialog;